import uniqid from 'uniqid';
import { ServerAlertData } from '../types/ServerAlertData';
import { ServerAlertAction } from '../types/ServerAlertAction';

let defaultState: ServerAlertData[] = [];

const serverAlertReducer = (state: ServerAlertData[] = defaultState, action: ServerAlertAction) => {

    switch (action.type) {
        case 'SHOW_ALERT': {
            const id = uniqid();
            return state.concat({...action.data, id});
        }
        case 'HIDE_ALERT': {
            const { id } = action.data;
            return state.filter((data) => data.id !== id);
        }
        default:
            return state;
    }

}

export default serverAlertReducer;